/* dp-ab.js — de A/B-splitsing van dailyplay.nl (Wim, 26-09-2026). Bron in git: shopify/dp-ab.js;
   in het thema: assets/dp-ab.js, geladen in layout/theme.liquid (defer) achter de schakelaar dp_ab_aan.

   WAT HET DOET, EN NIET MEER: op een productpagina vraagt het de cockpit welke shoptests lopen
   (/api/abtests?publiek=1: alleen id, kanaal, gestart en het recept — geen hypothese, niets geheims).
   Loopt er een test voor deze pagina, dan krijgt de browser één keer een variant (50/50, vast in
   localStorage én een cookie van 180 dagen) en meldt het een paginabezoek. Variant B krijgt het
   recept toegepast; vandaag bestaat er één recept: "galerij-clip" — een korte stille clip op plek N
   van de galerij. Een pop zonder clip in het recept blijft A en meldt variant "geen" (Cas: telt
   dan niet mee). Bij een toevoeging aan de winkelwagen meldt het een toevoeging en zet het het
   winkelwagen-kenmerk ab_<test> = A|B (attributen worden gemergd, zie KENNIS), zodat de order het
   draagt. Meldingen gaan met sendBeacon naar /api/ab-gebeurtenis; een storing daar raakt de
   winkel nooit. Niets hier raakt de checkout.

   Proef: ?dp_ab=A of ?dp_ab=B kiest de variant voor deze browser en markeert elke melding als proef
   (p=1), zodat een testbezoek de cijfers niet vervuilt; de proef ziet ook een test die nog op Damians
   akkoord wacht (&proef=1), een gewone bezoeker nooit. ?dp_ab=weg wist de keuze.

   Sinds 29-09 ook de HERO-TEST op de homepage (recept "hero-beeld", alleen desktop): elke desktopbezoeker
   krijgt gelijk verdeeld één van de armen (B1, B2, B3) als hero-beeld, het origineel doet niet mee, en het script meldt landing, vervolg en tijd op de homepage (zie startHero hieronder). Daarvoor
   onthoudt het op élke pagina één kleine sessie-stand in localStorage (dp-ab-sessie: laatste weergave + de
   landing van deze sessie); op een pagina zonder lopende test verstuurt het niets.

   Sinds 23-10 de GEDWONGEN VARIANT: houdt Damian een andere variant dan A, dan blijft de test in de lijst met
   vast: <variant> tot de vakagent hem in het thema bouwde en afmeldde (lib/abtests.js gedwongenVariant). Dan krijgt
   iedere bezoeker die variant: geen loting, niets onthouden, geen melding, geen kenmerk op de wagen.

   Geen enkele bezoeker-gegeven verlaat de browser behalve twee willekeurige id's (bezoeker, weergave); bij een
   landing zet de cockpit er het LAND bij uit de kop van Vercel, nooit het IP.
   Alles staat in try/catch: faalt iets, dan is de pagina precies wat hij zonder dit script was. */
(function () {
  "use strict";
  var COCKPIT = "https://dailyplay-cockpit.vercel.app";
  var CONFIG_SLEUTEL = "dp-ab-config-v1";
  var CONFIG_TTL_MS = 5 * 60 * 1000;
  var BEZOEKER_SLEUTEL = "dp-ab-bezoeker";
  var DAGEN_COOKIE = 180;

  function handleVanPad() {
    var m = (location.pathname || "").match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }
  function toeval(n) {
    var s = "";
    while (s.length < n) s += Math.random().toString(36).slice(2);
    return s.slice(0, n);
  }
  function lees(sleutel) { try { return localStorage.getItem(sleutel); } catch (e) { return null; } }
  function schrijf(sleutel, waarde) { try { localStorage.setItem(sleutel, waarde); } catch (e) { /* privé-venster */ } }
  function cookie(naam, waarde, dagen) {
    try {
      var uit = naam + "=" + encodeURIComponent(waarde) + "; path=/; max-age=" + (dagen * 86400) + "; SameSite=Lax";
      if (location.protocol === "https:") uit += "; Secure";
      document.cookie = uit;
    } catch (e) { /* niets */ }
  }
  function leesCookie(naam) {
    try {
      var m = document.cookie.match(new RegExp("(?:^|; )" + naam + "=([^;]*)"));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }
  function apparaat() { return window.matchMedia && window.matchMedia("(max-width: 768px)").matches ? "mobiel" : "desktop"; }
  function bezoekerId() {
    var id = lees(BEZOEKER_SLEUTEL);
    if (!id) { id = toeval(16); schrijf(BEZOEKER_SLEUTEL, id); }
    return id;
  }
  function proefKeuze() {
    var m = (location.search || "").match(/[?&]dp_ab=([^&]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /** De variant van deze browser voor deze test: localStorage eerst, dan de cookie, anders loten. `keuzes` = de
      armen (standaard A en B; de hero-test sinds 29-09: B1, B2, B3), gelijk verdeeld; een bewaarde keuze die geen
      arm (meer) is, wordt opnieuw geloot. */
  function variantVoor(testId, keuzes) {
    keuzes = keuzes && keuzes.length ? keuzes : ["A", "B"];
    var sleutel = "dp-ab-groep-" + testId;
    var proef = proefKeuze();
    if (proef === "weg") { schrijf(sleutel, ""); cookie("dp_ab_" + testId, "", 0); return null; }
    if (proef && keuzes.indexOf(proef) >= 0) { schrijf(sleutel, proef); cookie("dp_ab_" + testId, proef, DAGEN_COOKIE); return proef; }
    var v = lees(sleutel) || leesCookie("dp_ab_" + testId);
    if (keuzes.indexOf(v) < 0) {
      v = keuzes[Math.floor(Math.random() * keuzes.length)];
      schrijf(sleutel, v);
      cookie("dp_ab_" + testId, v, DAGEN_COOKIE);
    }
    return v;
  }

  function meld(rij) {
    try {
      var body = JSON.stringify(rij);
      if (navigator.sendBeacon && navigator.sendBeacon(COCKPIT + "/api/ab-gebeurtenis", body)) return;
      fetch(COCKPIT + "/api/ab-gebeurtenis", { method: "POST", body: body, keepalive: true, mode: "cors" }).catch(function () {});
    } catch (e) { /* een storing in de teller raakt de winkel nooit */ }
  }

  /** De lopende shoptests, vijf minuten gecachet per tabblad. */
  function haalConfig() {
    // de proef (?dp_ab=…) leest altijd vers én mag ook een test zien die nog op akkoord wacht
    var proef = proefKeuze() !== null;
    if (!proef) {
      try {
        var c = JSON.parse(sessionStorage.getItem(CONFIG_SLEUTEL) || "null");
        if (c && c.op && Date.now() - c.op < CONFIG_TTL_MS && Array.isArray(c.tests)) return Promise.resolve(c.tests);
      } catch (e) { /* door naar de cockpit */ }
    }
    return fetch(COCKPIT + "/api/abtests?publiek=1" + (proef ? "&proef=1" : ""), { mode: "cors", credentials: "omit" })
      .then(function (r) { return r.ok ? r.json() : { tests: [] }; })
      .then(function (d) {
        var tests = Array.isArray(d.tests) ? d.tests : [];
        if (!proef) { try { sessionStorage.setItem(CONFIG_SLEUTEL, JSON.stringify({ op: Date.now(), tests: tests })); } catch (e) { /* niets */ } }
        return tests;
      })
      .catch(function () { return []; });
  }

  /* ── recept "galerij-clip": een stille clip op plek N van de galerij ───────────────────────── */
  function zetClip(recept, handle) {
    var clip = recept && recept.clips ? recept.clips[handle] : null;
    if (!clip || !clip.url) return false;
    var items = document.querySelectorAll(".product-gallery__media");
    if (!items.length) return false;
    var positie = Math.max(1, Math.min(Number(recept.positie) || 2, items.length + 1));
    var na = items[positie - 2] || items[0];
    var vak = document.createElement("div");
    vak.className = na.className.replace(/product-gallery__media--expand/g, "").trim();
    vak.setAttribute("data-media-type", "video");
    vak.setAttribute("data-media-id", "dp-ab-clip");
    vak.setAttribute("data-dp-ab", "clip");
    var video = document.createElement("video");
    video.className = "dp-ab-clip";
    video.muted = true; video.loop = true; video.autoplay = true; video.playsInline = true;
    video.setAttribute("muted", ""); video.setAttribute("loop", ""); video.setAttribute("autoplay", ""); video.setAttribute("playsinline", "");
    video.setAttribute("preload", "metadata");
    if (clip.poster) video.setAttribute("poster", clip.poster);
    video.setAttribute("aria-label", "korte video van het product");
    video.style.cssText = "display:block;width:100%;height:100%;object-fit:cover;background:#000";
    var bron = document.createElement("source");
    bron.src = clip.url; bron.type = "video/mp4";
    video.appendChild(bron);
    vak.appendChild(video);
    if (positie === 1) na.parentNode.insertBefore(vak, na); else na.insertAdjacentElement("afterend", vak);
    // Impact's <media-carousel> las zijn media bij het aansluiten: met een item erbij bladert hij nog over de
    // oude lijst (Damian 26-09 op desktop: "als ik scroll dan zie ik het 1 keer en als ik terug scroll krijg ik
    // de video niet meer"). Opnieuw aansluiten = een kloon van het hele element; de video wordt daarna opnieuw
    // opgezocht, want de oude knoop is dan weg.
    var carrousel = na.closest("media-carousel");
    if (carrousel && carrousel.parentNode) {
      carrousel.parentNode.replaceChild(carrousel.cloneNode(true), carrousel);
      // de pijlknoppen (is="prev-button"/"next-button") hingen met hun aan/uit-stand aan de oude carrousel
      // (gemeten 26-09: "vorige" bleef uit staan na de kloon); opnieuw aansluiten, dan luisteren ze naar de nieuwe
      document.querySelectorAll('button[is="prev-button"][aria-controls="' + carrousel.id + '"], button[is="next-button"][aria-controls="' + carrousel.id + '"]').forEach(function (knop) {
        if (knop.parentNode) knop.parentNode.replaceChild(knop.cloneNode(true), knop);
      });
    }
    // de puntjes op mobiel én de thumbnails links op desktop zijn allebei een <page-dots>: één knop erbij, op
    // dezelfde plek, met de poster als plaatje. <page-dots> las zijn knoppen óók bij het aansluiten (gemeten
    // 26-09: de teller sprong op de clip naar "3/14"), dus ook dat element sluit opnieuw aan, en dit script houdt
    // zelf de teller "x/n" bij: x = de plek van de actieve knop, n = het aantal media inclusief de clip.
    document.querySelectorAll("page-dots").forEach(function (dots) {
      var knoppen = dots.querySelectorAll("button");
      if (!knoppen.length) return;
      var punt = knoppen[Math.min(positie - 2, knoppen.length - 1)].cloneNode(true);
      punt.setAttribute("aria-current", "false");
      punt.removeAttribute("hidden");
      punt.setAttribute("data-dp-ab", "punt");
      var plaatje = punt.querySelector("img");
      if (plaatje) {
        if (clip.poster) plaatje.setAttribute("src", clip.poster);
        plaatje.removeAttribute("srcset"); plaatje.removeAttribute("sizes");
        plaatje.setAttribute("alt", "video");
      }
      if (positie === 1) knoppen[0].parentNode.insertBefore(punt, knoppen[0]); else knoppen[Math.min(positie - 2, knoppen.length - 1)].insertAdjacentElement("afterend", punt);
      var vers = dots.cloneNode(true);
      dots.parentNode.replaceChild(vers, dots);
      var teller = document.querySelector('[data-gallery-counter-for="' + vers.getAttribute("aria-controls") + '"]');
      if (!teller) return;
      var totaal = teller.querySelector("[data-gallery-counter-total]");
      if (totaal) totaal.textContent = document.querySelectorAll(".product-gallery__media").length;
      var huidig = teller.querySelector("[data-gallery-counter-current]");
      if (!huidig || !window.MutationObserver) return;
      Array.prototype.forEach.call(vers.children, function (b, i) {
        new MutationObserver(function () { if (b.getAttribute("aria-current") === "true") huidig.textContent = i + 1; })
          .observe(b, { attributes: true, attributeFilter: ["aria-current"] });
      });
    });
    var speel = function () {
      try {
        // ná het opnieuw aansluiten van de carrousel is `video` een losse knoop: de levende staat in de DOM
        var v = document.querySelector('[data-dp-ab="clip"] video') || video;
        v.muted = true; v.loop = true; v.playsInline = true;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } catch (e) { /* autoplay geweigerd: de poster blijft */ }
    };
    if (document.readyState === "complete") speel(); else window.addEventListener("load", speel, { once: true });
    // Impact zet elke video stil zodra je van slide wisselt en start alleen zijn eigen <video-media> weer; onze
    // clip bleef dus stilstaan zodra je terugbladerde (Damian 26-09: "als ik terug scroll krijg ik de video niet
    // meer"). Daarom: speelt de clip opnieuw zodra zijn slide geselecteerd is of in beeld komt.
    try {
      var levend = document.querySelector('[data-dp-ab="clip"]');
      if (levend && window.MutationObserver) {
        new MutationObserver(function () { if (levend.classList.contains("is-selected")) speel(); })
          .observe(levend, { attributes: true, attributeFilter: ["class"] });
      }
      if (levend && window.IntersectionObserver) {
        new IntersectionObserver(function (ingangen) {
          ingangen.forEach(function (i) { if (i.isIntersecting && i.intersectionRatio >= 0.5) speel(); });
        }, { threshold: [0.5] }).observe(levend);
      }
    } catch (e) { /* zonder observer speelt hij één keer, zoals eerst */ }
    return true;
  }

  /* ── de toevoeging aan de winkelwagen: /cart/add via fetch of XHR ──────────────────────────── */
  function bewaakToevoegen(bij) {
    var gemeld = false;
    function raak(url) {
      try { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || "")); } catch (e) { return false; }
    }
    function toevoeging() {
      if (gemeld) return;   // één melding per paginabezoek: de teller telt toevoegingen per bezoek
      gemeld = true;
      bij();
    }
    if (window.fetch) {
      var oudFetch = window.fetch;
      window.fetch = function (invoer, opties) {
        var url = typeof invoer === "string" ? invoer : (invoer && invoer.url);
        var p = oudFetch.apply(this, arguments);
        if (raak(url)) p.then(function (r) { if (r && r.ok) toevoeging(); }, function () {});
        return p;
      };
    }
    if (window.XMLHttpRequest) {
      var oudOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (methode, url) {
        if (raak(url)) this.addEventListener("load", function () { if (this.status >= 200 && this.status < 300) toevoeging(); });
        return oudOpen.apply(this, arguments);
      };
    }
    // een gewoon formulier zonder JS (zeldzaam, maar dan is de pagina weg vóór de fetch-haak vuurt)
    document.addEventListener("submit", function (e) {
      var f = e.target;
      if (f && f.getAttribute && raak(f.getAttribute("action"))) toevoeging();
    }, true);
  }

  function kenmerkOpWagen(testId, variant) {
    try {
      var attributen = {};
      attributen["ab_" + testId] = variant;
      fetch("/cart/update.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes: attributen }),
      }).catch(function () {});
    } catch (e) { /* niets */ }
  }

  /* ── de hero-test op de homepage (29-09-2026, Cas): alleen desktop, bounce en tijd ────────────────────
     Een SESSIE is hier wat Shopify ook zo noemt: 30 minuten zonder paginaweergave = een nieuwe. Begint een
     sessie op de homepage op desktop terwijl er een hero-test loopt, dan is dat een LANDING (melding met de
     variant). Elke volgende paginaweergave in dezelfde sessie — elke pagina, ook in een ander tabblad — meldt
     één keer VERVOLG bij die landing; een landing zonder vervolg is een bounce. De TIJD is de zichtbare tijd op
     de homepage tot de bezoeker hem verlaat of het tabblad wegklikt, afgekapt op TIJD_KAP_S. Een browser ziet op
     élke homepage-weergave (desktop) het beeld van zijn arm, gemeten wordt alleen de landing. Mobiel: niets, nooit. */
  var SESSIE_SLEUTEL = "dp-ab-sessie";
  var SESSIE_MS = 30 * 60 * 1000;
  var TIJD_KAP_S = 300;
  var HERO_URL = /^https:\/\/cdn\.shopify\.com\/[^"'()\s<>]+$/;
  function isHome() { return (location.pathname || "/") === "/"; }
  // het breekpunt van het thema zelf (hero-banner: mobiel tot 767 px), niet dat van apparaat()
  function isDesktop() { return !!(window.matchMedia && window.matchMedia("(min-width: 768px)").matches); }
  function leesSessie() { try { return JSON.parse(lees(SESSIE_SLEUTEL) || "null"); } catch (e) { return null; } }

  /** Eén keer per paginaweergave: begint hier een nieuwe sessie, en hoort er een vervolg bij een eerdere landing? */
  function sessie() {
    var nu = Date.now(), s = leesSessie();
    var nieuw = !s || !s.laatst || nu - s.laatst > SESSIE_MS;
    if (nieuw) s = { laatst: nu, landing: null, id: toeval(16) };
    if (!s.id) s.id = toeval(16);   // een sessie van vóór 29-09 kreeg nog geen id (de lade-test telt per sessie)
    else if (s.landing && !s.landing.vervolg && s.landing.basis) {
      meld(Object.assign({ s: "vervolg" }, s.landing.basis));
      s.landing.vervolg = true;
    }
    s.laatst = nu;
    schrijf(SESSIE_SLEUTEL, JSON.stringify(s));
    return { nieuw: nieuw };
  }

  /** Het B-beeld in de hero, alleen op desktop (een eigen stijlregel binnen de media query van het thema). */
  /** De armen van het hero-recept die een bruikbaar beeld hebben (de winkel krijgt alleen gekeurde). */
  function heroKeuzes(recept) {
    var v = (recept && recept.varianten) || {};
    return ["B", "B1", "B2", "B3", "B4"].filter(function (k) { return v[k] && v[k].url && HERO_URL.test(v[k].url); });
  }

  /* Zonder flits (05-10-2026): layout/theme.liquid zet vóór de eerste weergave óf het onthouden beeld van de arm
     (HERO_ONTHOUD, stijl "hero-vroeg") óf de klasse dp-hero-wacht op <html> (lege hero, uiterlijk load + 1,5 s en nooit langer dan 6 s). Dit script
     laadt het beeld eerst en haalt de klasse pas weg als het er is, zodat er nooit een half geladen of oud beeld staat. */
  var HERO_ONTHOUD = "dp-ab-hero-url";
  function heroKlaar() { try { document.documentElement.classList.remove("dp-hero-wacht"); } catch (e) { /* niets */ } }
  /** Geen hero-test (meer): het onthouden beeld en de vroege stijl weg, de hero is weer het origineel. */
  function heroVergeet() {
    try { localStorage.removeItem(HERO_ONTHOUD); } catch (e) { /* niets */ }
    var vroeg = document.querySelector('style[data-dp-ab="hero-vroeg"]');
    if (vroeg) vroeg.parentNode.removeChild(vroeg);
    heroKlaar();
  }

  function zetHero(recept, arm) {
    var url = recept && recept.varianten && recept.varianten[arm] && recept.varianten[arm].url;
    if (!url || !HERO_URL.test(url)) return false;
    var vak = document.querySelector(".hero-banner-container");
    if (!vak) return false;
    vak.setAttribute("data-dp-ab", "hero");
    var stijl = document.createElement("style");
    stijl.setAttribute("data-dp-ab", "hero-stijl");
    stijl.textContent = '@media screen and (min-width: 768px){.hero-banner-container[data-dp-ab="hero"]{background-image:url("' + url + '") !important}}';
    document.head.appendChild(stijl);
    schrijf(HERO_ONTHOUD, url);
    // de lege hero blijft tot het beeld binnen is (of mislukt), nooit langer dan het vangnet in theme.liquid (load + 1,5 s, hooguit 6 s)
    try { var beeld = new Image(); beeld.onload = beeld.onerror = heroKlaar; beeld.src = url; if (beeld.complete) heroKlaar(); } catch (e) { heroKlaar(); }
    return true;
  }

  function startHero(ss) {
    if (!isHome() || !isDesktop()) return;
    var proef = proefKeuze() !== null;
    haalConfig().then(function (tests) {
      var test = null;
      for (var i = 0; i < tests.length; i++) {
        var t = tests[i];
        if (t && t.kanaal === "shop" && t.recept && t.recept.soort === "hero-beeld") { test = t; break; }
      }
      if (!test) { heroVergeet(); return; }
      // gehouden, nog niet in het thema gebouwd (23-10, lib/abtests.js gedwongenVariant): iedereen die arm, geen loting, geen melding
      if (test.vast) { if (!zetHero(test.recept, test.vast)) heroVergeet(); return; }
      // de armen (29-09: B1, B2, B3 gelijk verdeeld; het origineel doet niet mee)
      var keuzes = heroKeuzes(test.recept);
      if (!keuzes.length) { heroVergeet(); return; }
      var variant = variantVoor(test.id, keuzes);
      if (!variant) { heroVergeet(); return; }
      var gedaan = zetHero(test.recept, variant);
      if (!gedaan) heroVergeet();
      // gemeten wordt alleen een LANDING (het begin van een sessie); de proef meldt altijd, als proef
      if (!ss.nieuw && !proef) return;
      var basis = { t: test.id, v: gedaan ? variant : "geen", h: "home", w: toeval(16), b: bezoekerId(), a: "desktop" };
      if (proef) basis.p = 1;
      meld(Object.assign({ s: "landing" }, basis));
      if (!gedaan) return;   // B zonder beeld telt als "geen": alleen de landing, voor de controle
      var s = leesSessie() || { laatst: Date.now() };
      s.landing = { basis: basis, vervolg: false };
      schrijf(SESSIE_SLEUTEL, JSON.stringify(s));
      // een tabblad dat op de achtergrond openging telt geen tijd: er was niets zichtbaar
      if (document.visibilityState && document.visibilityState !== "visible") return;
      var weg = false;
      var vertrek = function () {
        if (weg) return;
        weg = true;
        var sec = window.performance && performance.now ? Math.round(performance.now() / 1000) : 0;
        meld(Object.assign({ s: "tijd", n: Math.max(0, Math.min(TIJD_KAP_S, sec)) }, basis));
      };
      document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") vertrek(); });
      window.addEventListener("pagehide", vertrek);
    }).catch(function () { heroKlaar(); });
  }

  /* ── hero-test: winkelwagens en verkopen (08-10-2026, Damian: "ook verkopen als metriek") ─────────────────
     Op élke pagina (ook mobiel, ook na het eerste bezoek): heeft deze browser een hero-arm, dan meldt de eerste
     toevoeging aan de wagen in een sessie een "wagen" (weergave = "h" + sessie-id, zodat hij nooit botst met de
     lade-"wagen" van dezelfde sessie) en krijgt de wagen het kenmerk ab_<test> = arm, zodat de order de arm draagt.
     Geen arm (nooit op de desktop-homepage geweest) = niets. De proef (?dp_ab=…) meldt als proef. */
  function startHeroWagen() {
    haalConfig().then(function (tests) {
      var test = null;
      for (var i = 0; i < tests.length; i++) {
        var t = tests[i];
        if (t && t.kanaal === "shop" && t.recept && t.recept.soort === "hero-beeld") { test = t; break; }
      }
      if (!test || test.vast) return;   // een gehouden test meet niets meer
      var arm = lees("dp-ab-groep-" + test.id) || leesCookie("dp_ab_" + test.id);
      if (heroKeuzes(test.recept).indexOf(arm) < 0) return;
      var proef = proefKeuze() !== null;
      bewaakToevoegen(function () {
        var b = { t: test.id, v: arm, h: "home", w: "h" + sessieId(), b: bezoekerId(), a: apparaat(), s: "wagen" };
        if (proef) b.p = 1;
        meld(b);
        kenmerkOpWagen(test.id, arm);
      });
    }).catch(function () {});
  }

  /* ── de lade-upsell-test (29-09-2026, Cas): welke upsell-kaarten van Kaching een bezoeker in de lade ziet ──
     Kaching kan per bezoeker niets splitsen, dus dit script kiest per variant uit de kaarten die Kaching zelf
     tekent (elke kaart draagt data-product-handle). A = recept.varianten.A in de volgorde van Kaching; wat daar niet
     in staat wordt verborgen. B = recept.varianten.B, per wagen gefilterd en geordend (de regels in lib/abtests.js
     keurLadeRecept), getoond als één pagina kaarten in Kachings eigen opmaak (kopieën van zijn kaarten); een klik op
     "In winkelwagen" van een kopie klikt Kachings eigen knop, zodat de upsell-korting van Kaching blijft gelden.
     Meldingen: één "wagen" per sessie zodra de lade met iets in de wagen is getekend (en dan het kenmerk ab_<test>
     op de wagen, voor de orders), en één "upsell" per sessie bij de eerste klik op een upsell-knop. */
  var LADE_MODULE = ".kaching-upsell-module--product-upsell";
  var LADE_KAART = ".kaching-product-upsell-item";
  var LADE_KNOP = ".kaching-product-upsell-item__add-to-cart";
  function sessieId() {
    var s = leesSessie() || { laatst: Date.now(), landing: null };
    if (!s.id) { s.id = toeval(16); schrijf(SESSIE_SLEUTEL, JSON.stringify(s)); }
    return s.id;
  }
  function prijsVan(kaart) {
    var el = kaart.querySelector(".kaching-product-upsell-item__price-final");
    var n = parseFloat((el ? el.textContent : "").replace(/[^0-9,]/g, "").replace(",", "."));
    return isFinite(n) ? n : null;
  }
  var tagsCache = {};
  function tagsVan(handle) {
    if (!tagsCache[handle]) {
      tagsCache[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return ((p && p.tags) || []).map(function (t) { return String(t).toLowerCase(); }); })
        .catch(function () { return []; });
    }
    return tagsCache[handle];
  }
  /** De titels van de gratis accessoires van de producten in de wagen (dezelfde bron als dp-cart.js). */
  function cadeauTitels() {
    return fetch("/?sections=dp-cart-cadeaus", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j["dp-cart-cadeaus"];
        var m = html && html.match(/<script type="application\/json" data-dp-cadeaus>([\s\S]*?)<\/script>/);
        var data = m ? JSON.parse(m[1]) : {};
        var uit = [];
        Object.keys(data).forEach(function (k) { (data[k] || []).forEach(function (g) { if (g && g.t) uit.push(String(g.t).toLowerCase()); }); });
        return uit;
      })
      .catch(function () { return []; });
  }
  /** Wat de B-regels over deze wagen moeten weten: totaal, masturbator/pop erin, en welke handles al gratis zijn. */
  var ladeCtx = { sig: null, belofte: null };
  function wagenContext(recept) {
    return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).filter(function (i) { return !(i.properties && i.properties._kaching_cart && /promoHash/.test(String(i.properties._kaching_cart))); });
        var sig = items.map(function (i) { return i.handle + ":" + i.quantity; }).join("|");
        if (ladeCtx.sig === sig && ladeCtx.belofte) return ladeCtx.belofte;
        ladeCtx.sig = sig;
        var g = recept.regels || {};
        ladeCtx.belofte = Promise.all([Promise.all(items.map(function (i) { return tagsVan(i.handle); })), cadeauTitels()]).then(function (res) {
          var alleTags = [].concat.apply([], res[0]);
          var heeft = function (lijst) { return (lijst || []).some(function (t) { return alleTags.indexOf(t) >= 0; }); };
          var gratis = [];
          (g.gratisDekt || []).forEach(function (x) { if (res[1].some(function (titel) { return titel.indexOf(x.woord) >= 0; })) gratis = gratis.concat(x.handles); });
          return { totaal: (cart.total_price || 0) / 100, aantal: cart.item_count || 0, masturbator: heeft(g.masturbatorTags), pop: heeft(g.popTags), gratis: gratis, inWagen: items.map(function (i) { return i.handle; }) };
        });
        return ladeCtx.belofte;
      });
  }
  /** De volgende cadeautrede van Kaching (live uit zijn instellingen) boven het totaal: {drempel, titel} of null. */
  function volgendeTrede(totaal) {
    try {
      var tiers = window.__kachingCartProps.cartSettings.tieredPromotionsBar;
      if (!tiers || !tiers.isActive) return null;
      var kandidaten = (tiers.tiers || []).filter(function (t) { return t.type === "product-discount" && t.threshold > totaal; })
        .sort(function (a, b) { return a.threshold - b.threshold; });
      return kandidaten.length ? { drempel: kandidaten[0].threshold, titel: kandidaten[0].title } : null;
    } catch (e) { return null; }
  }
  /** B: welke handles, in welke volgorde, voor deze wagen. `kaarten` = wat Kaching nu tekent (handle -> {prijs}). */
  function ladeKeuzeB(recept, kaarten, ctx) {
    var g = recept.regels || {};
    var lijst = recept.varianten.B.filter(function (h) {
      if (!kaarten[h]) return false;                                            // Kaching tekent hem niet (op, in wagen)
      if (ctx.gratis.indexOf(h) >= 0) return false;                             // (1) al gratis erbij
      if (ctx.pop && kaarten[h].prijs != null && kaarten[h].prijs < (g.popMinPrijs || 0)) return false;   // (3) pop: niets goedkoops
      return true;
    });
    if (ctx.masturbator && (g.hoofd || []).length) {                            // (2) masturbator: eerst een hoofdproduct
      lijst = lijst.filter(function (h) { return g.hoofd.indexOf(h) >= 0; }).concat(lijst.filter(function (h) { return g.hoofd.indexOf(h) < 0; }));
    }
    return lijst.slice(0, g.max || 3);
  }
  function tekenLade(test, variant) {
    var module = document.querySelector(LADE_MODULE);
    if (!module) return;
    var origineel = module.querySelectorAll(".kaching-cart__carousel:not(.dp-ab-lade) " + LADE_KAART);
    var kaarten = {};
    Array.prototype.forEach.call(origineel, function (k) { kaarten[k.getAttribute("data-product-handle")] = { el: k, prijs: prijsVan(k) }; });
    var recept = test.recept;
    if (variant === "A") {
      // A: precies de kaarten van nu; wat later in de pool bijkomt blijft verborgen
      Array.prototype.forEach.call(origineel, function (k) {
        var weg = recept.varianten.A.indexOf(k.getAttribute("data-product-handle")) < 0;
        if (weg) k.style.display = "none";
      });
      Array.prototype.forEach.call(module.querySelectorAll(".kaching-cart__carousel-item"), function (li) {
        var zichtbaar = Array.prototype.some.call(li.querySelectorAll(LADE_KAART), function (k) { return k.style.display !== "none"; });
        if (!zichtbaar) li.style.display = "none";
      });
      return;
    }
    wagenContext(recept).then(function (ctx) {
      var keuze = ladeKeuzeB(recept, kaarten, ctx);
      var trede = volgendeTrede(ctx.totaal);
      var sig = keuze.join(",") + "|" + ctx.totaal + "|" + (trede ? trede.drempel : "");
      var bestaand = module.querySelector(".dp-ab-lade");
      var carrousel = module.querySelector(".kaching-cart__carousel:not(.dp-ab-lade)");
      if (!carrousel) return;
      // tekent Kaching zijn carrousel opnieuw terwijl onze keuze gelijk blijft: alleen zijn nieuwe carrousel weer weg
      if (bestaand && bestaand.getAttribute("data-sig") === sig) { if (keuze.length) carrousel.style.display = "none"; return; }
      // Kachings eigen opbouw (knop, lijst, knop) met zijn klassen, zodat de kaarten er precies zo uitzien als
      // bij A: een ondiepe kopie van de carrousel, één pagina, de pijlen onzichtbaar maar op hun plek
      var vak = carrousel.cloneNode(false);
      vak.classList.add("dp-ab-lade");
      vak.removeAttribute("style");
      vak.setAttribute("data-sig", sig);
      // de pijlen: onzichtbaar maar op hun plek (één pagina, niets te bladeren); Kaching zet zelf display, dus !important
      // (opacity en geen visibility: Kachings CSS zet het pijl-icoon zelf op visible, gemeten 29-09)
      var pijl = function (k) { var p = k.cloneNode(true); p.style.setProperty("opacity", "0", "important"); p.style.setProperty("pointer-events", "none", "important"); p.setAttribute("tabindex", "-1"); p.setAttribute("aria-hidden", "true"); return p; };
      var vorige = carrousel.querySelector(".kaching-cart__carousel-prev"), volgende = carrousel.querySelector(".kaching-cart__carousel-next");
      var lijstOrigineel = carrousel.querySelector(".kaching-cart__carousel-list");
      var paginaOrigineel = carrousel.querySelector(".kaching-cart__carousel-item");
      var ul = lijstOrigineel ? lijstOrigineel.cloneNode(false) : document.createElement("ul");
      ul.removeAttribute("style");
      if (!lijstOrigineel) ul.className = "kaching-cart__carousel-list";
      var li = paginaOrigineel ? paginaOrigineel.cloneNode(false) : document.createElement("li");
      li.removeAttribute("style");
      if (!paginaOrigineel) li.className = "kaching-cart__carousel-item kaching-product-upsell-item-container kaching-cart-carousel-item-layout-3";
      keuze.forEach(function (h) {
        var kopie = kaarten[h].el.cloneNode(true);
        kopie.style.display = "";
        kopie.setAttribute("data-dp-ab", "kopie");
        // (4) overbrugt deze kaart het gat naar de volgende cadeautrede van Kaching? Zeg dan welk cadeau erbij komt
        var prijs = kaarten[h].prijs;
        if (trede && prijs != null && ctx.totaal + prijs >= trede.drempel) {
          var regel = document.createElement("div");
          regel.className = "dp-ab-lade__trede";
          regel.style.cssText = "font-size:12px;margin-top:4px;font-weight:600";
          regel.textContent = "en je krijgt de " + trede.titel + " gratis";
          var inhoud = kopie.querySelector(".kaching-product-upsell-item__content") || kopie;
          inhoud.appendChild(regel);
        }
        var knop = kopie.querySelector(LADE_KNOP);
        if (knop) knop.addEventListener("click", function (e) {
          e.preventDefault(); e.stopPropagation();
          var echt = kaarten[h].el.querySelector(LADE_KNOP);
          if (echt) echt.click();
        });
        li.appendChild(kopie);
      });
      ul.appendChild(li);
      if (vorige) vak.appendChild(pijl(vorige));
      vak.appendChild(ul);
      if (volgende) vak.appendChild(pijl(volgende));
      if (bestaand) bestaand.parentNode.replaceChild(vak, bestaand);
      else carrousel.parentNode.insertBefore(vak, carrousel.nextSibling);
      carrousel.style.display = "none";
      if (!keuze.length) vak.style.display = "none";
    }).catch(function () { /* bij twijfel: Kaching zoals hij is */ var c = module.querySelector(".kaching-cart__carousel:not(.dp-ab-lade)"); if (c) c.style.display = ""; });
  }
  /** Krijgt deze browser de nieuwe lade? Dezelfde regel als paginaArm() in assets/dp-lade.js. */
  function paginaArmB() {
    var T = "mvmq7ych-34xx7j", open = lees("dp-ab-open-" + T);
    if (open === "B") return true;
    if (open !== "1" && lees("dp-ab-proef-" + T) !== "1") return false;
    return (lees("dp-ab-groep-" + T) || leesCookie("dp_ab_" + T)) === "B";
  }
  function startLade() {
    haalConfig().then(function (tests) {
      var test = null;
      for (var i = 0; i < tests.length; i++) {
        var t = tests[i];
        if (t && t.kanaal === "shop" && t.recept && t.recept.soort === "lade-upsell" && t.recept.varianten) { test = t; break; }
      }
      if (!test) return;
      // vóór de start (of gepauzeerd): iedereen ziet A, de kaarten van nu — geen loting, geen melding, geen kenmerk.
      // Gehouden en nog niet vastgezet (23-10, test.vast): iedereen die variant, net zo stil.
      var alleenA = test.voorStart === true || !!test.vast;
      var variant = test.vast ? test.vast : (test.voorStart === true ? "A" : variantVoor(test.id));
      if (!variant) return;
      // 24-10-2026: een browser in arm B van de paginatest ziet de nieuwe lade (assets/dp-lade.js). Die tekent dezelfde
      // upsell-kaarten van zijn variant, maar telt niet mee in deze test: geen "wagen", geen "upsell", geen kenmerk.
      // Zo meet de upsell-test alleen nog op de lade waarvoor hij bedacht is.
      if (paginaArmB()) alleenA = true;
      var proef = proefKeuze() !== null;
      var basis = function () {
        var b = { t: test.id, v: variant, h: "lade", w: sessieId(), b: bezoekerId(), a: apparaat() };
        if (proef) b.p = 1;
        return b;
      };
      var gemeld = { wagen: false, upsell: false };
      var bezig = null;
      var ronde = function () {
        bezig = null;
        var module = document.querySelector(LADE_MODULE);
        if (!module) return;
        if (!alleenA && !gemeld.wagen && module.querySelector(LADE_KAART)) {
          // een lade met upsell-kaarten wordt alleen getekend als er iets in de wagen ligt
          gemeld.wagen = true;
          meld(Object.assign({ s: "wagen" }, basis()));
          kenmerkOpWagen(test.id, variant);
        }
        tekenLade(test, variant);
      };
      var plan = function () { if (!bezig) bezig = setTimeout(ronde, 120); };
      if (window.MutationObserver) {
        new MutationObserver(function (lijst) {
          // eigen wijzigingen (de kopieën) negeren, anders tekent hij zichzelf eindeloos
          for (var i = 0; i < lijst.length; i++) {
            var doel = lijst[i].target;
            if (!(doel && doel.closest && doel.closest(".dp-ab-lade"))) { plan(); return; }
          }
        }).observe(document.body, { childList: true, subtree: true });
      }
      document.addEventListener("click", function (e) {
        var knop = e.target && e.target.closest && e.target.closest(LADE_KNOP);
        if (!knop || gemeld.upsell || alleenA) return;
        gemeld.upsell = true;
        meld(Object.assign({ s: "upsell" }, basis()));
      }, true);
      plan();
    }).catch(function () {});
  }

  /* ── de keuzehulp-test: winkelwagens en poppen (21-10-2026, akkoord Damian via Max: "Oke a/b dan") ───────────────
     De splitsing zelf en de meldingen bezoek · kh_start · kh_advies · kh_klik doet de sectie op de collectiepagina
     (shopify/dp-keuzehulp.liquid); die schrijft localStorage "dp-kh" = {t: test, v: arm (A, B of "geen" zonder
     splitsing), p: 1 bij een proef, pops: de handles van die collectie, op: ms}. Heeft deze browser dat, dan meldt
     dit op élke pagina de eerste toevoeging in een sessie als "wagen" en de eerste POP als "toevoeging" (h = de pop),
     beide met weergave "k" + sessie-id, en zet het het kenmerk ab_<test> = arm op de wagen, zodat checkout en order
     de arm dragen. Na KH_DAGEN dagen zonder nieuw bezoek aan de collectie telt een toevoeging niet meer mee.
     Zonder "dp-kh" doet dit niets. */
  var KH_DAGEN = 30;
  function startKeuzehulpWagen() {
    var kh = null;
    try { kh = JSON.parse(lees("dp-kh") || "null"); } catch (e) { kh = null; }
    if (!kh || !kh.t || ["A", "B", "geen"].indexOf(kh.v) < 0 || !(Date.now() - Number(kh.op) < KH_DAGEN * 864e5)) return;
    var pops = Array.isArray(kh.pops) ? kh.pops : [];
    var gemeld = { wagen: false, pop: false };
    function basis(s, h) {
      var b = { t: kh.t, v: kh.v, s: s, h: h, w: "k" + sessieId(), b: bezoekerId(), a: apparaat() };
      if (kh.p) b.p = 1;
      return b;
    }
    function verwerk(handles) {
      if (!gemeld.wagen) {
        gemeld.wagen = true;
        meld(basis("wagen", handles[0] || "wagen"));
        if (kh.v === "A" || kh.v === "B") kenmerkOpWagen(kh.t, kh.v);
      }
      if (gemeld.pop) return;
      for (var i = 0; i < handles.length; i++) {
        if (pops.indexOf(handles[i]) >= 0) { gemeld.pop = true; meld(basis("toevoeging", handles[i])); return; }
      }
    }
    function handlesUit(j) {
      var uit = [];
      var neem = function (x) { if (x && typeof x.handle === "string" && /^[a-z0-9][a-z0-9-]{1,80}$/.test(x.handle)) uit.push(x.handle); };
      if (j && Array.isArray(j.items)) j.items.forEach(neem); else neem(j);
      return uit;
    }
    function raak(url) {
      try { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || "")); } catch (e) { return false; }
    }
    var terug = function () { var h = handleVanPad(); return h ? [h] : []; };
    if (window.fetch) {
      var oudFetch = window.fetch;
      window.fetch = function (invoer) {
        var url = typeof invoer === "string" ? invoer : (invoer && invoer.url);
        var p = oudFetch.apply(this, arguments);
        if (raak(url)) p.then(function (r) {
          if (!r || !r.ok) return;
          try { r.clone().json().then(function (j) { var h = handlesUit(j); verwerk(h.length ? h : terug()); }, function () { verwerk(terug()); }); }
          catch (e) { verwerk(terug()); }
        }, function () {});
        return p;
      };
    }
    if (window.XMLHttpRequest) {
      var oudOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (methode, url) {
        if (raak(url)) this.addEventListener("load", function () {
          if (this.status < 200 || this.status >= 300) return;
          var h = []; try { h = handlesUit(JSON.parse(this.responseText)); } catch (e) { /* geen JSON */ }
          verwerk(h.length ? h : terug());
        });
        return oudOpen.apply(this, arguments);
      };
    }
  }

  /* ── de clip, VAST in het thema (24-10-2026): test muin65me "Bewegende clip op de productpagina's van de poppen" is
     gehouden met B. Tot vandaag gaf de cockpit hem als gedwongen variant door; nu staat hij hier, zodat hij los van het
     register blijft staan (Cas meldt de test af) en alleen op de pagina's met de oude galerij komt: op het nieuwe
     ontwerp (variant B van de paginatest mvmq7ych) is er geen galerij, dan doet zetClip niets. ───────────────────── */
  var VAST_CLIP = {
    test: "muin65me-w3jbv7",   // zolang het register deze test nog doorgeeft, slaat start() hem over: nooit twee keer een clip
    positie: 2,
    clips: {
      "esmee-sex-pop-voor-mannen": { url: "https://cdn.shopify.com/s/files/1/0714/5793/1573/files/dp-ab-clip-sara-1080.mp4?v=1792747182", poster: "https://cdn.shopify.com/s/files/1/0714/5793/1573/files/dp-ab-poster-sara-1080.jpg?v=1792747220" },
      "sara-sexpop-voor-mannen": { url: "https://cdn.shopify.com/s/files/1/0714/5793/1573/files/dp-ab-clip-esmee-1080.mp4?v=1792747150", poster: "https://cdn.shopify.com/s/files/1/0714/5793/1573/files/dp-ab-poster-esmee-1080.jpg?v=1792747188" },
      "loes-kunstvagina-en-kont": { url: "https://cdn.shopify.com/s/files/1/0714/5793/1573/files/dp-ab-clip-loes-1080.mp4?v=1792747166", poster: "https://cdn.shopify.com/s/files/1/0714/5793/1573/files/dp-ab-poster-loes-1080.jpg?v=1792747197" },
      "jessica-nep-kont": { url: "https://cdn.shopify.com/s/files/1/0714/5793/1573/files/dp-ab-clip-jessica-1080.mp4?v=1792747158", poster: "https://cdn.shopify.com/s/files/1/0714/5793/1573/files/dp-ab-poster-jessica-1080.jpg?v=1792747193" },
      "maud-sekspop": { url: "https://cdn.shopify.com/s/files/1/0714/5793/1573/files/dp-ab-clip-maud-1080.mp4?v=1792747174", poster: "https://cdn.shopify.com/s/files/1/0714/5793/1573/files/dp-ab-poster-maud-1080.jpg?v=1792747201" }
    }
  };

  /* ── de PAGINATEST (24-10-2026, test mvmq7ych van Cas, recept "thema-template"; Damian: "Oke, gooi maar live onder
     a/b test"; eisen: vaste variant per browser, homepage en aankondigingsbalk buiten de test, metrics in winkelwagen,
     tijd op pagina en verkopen). De doorsturing naar het template van de arm doet snippets/dp-split.liquid vóór de
     eerste weergave (window.dpSplit); dit deel doet wat pas kan als de cockpit antwoordt:
       · LOTEN: loopt de test (in de lijst, niet voorStart, niet vast), dan zet het dp-ab-open-<test> = 1; een browser
         zonder arm krijgt op zijn eerste testpagina 50/50 een arm (localStorage + cookie 180 dagen) en gaat meteen naar
         het template van die arm. Gehouden met B (vast): dp-ab-open = B, iedereen B, niets gemeld. Loopt hij niet: het
         vlaggetje weg, dan stuurt dp-split niemand meer door (behalve de proef).
       · MELDEN, met de arm en voor de proef als proef: "bezoek" op elke testpagina in het template van de arm (h = de
         pagina), "tijd" met de zichtbare seconden bij het verlaten van die pagina, "toevoeging" bij ELKE toevoeging op
         ELKE pagina (ook snel toevoegen en de lade; h = het product), en bij de eerste toevoeging het wagenkenmerk
         ab_<test> = arm, zodat de order (verkopen) de arm draagt. ───────────────────────────────────────────── */
  var TIJD_PAGINA_KAP_S = 300;
  function startPaginaTest() {
    var ds = window.dpSplit || null;
    var vind = function (tests) {
      for (var i = 0; i < tests.length; i++) {
        var t = tests[i];
        if (t && t.kanaal === "shop" && t.recept && t.recept.soort === "thema-template") return t;
      }
      return null;
    };
    // een proefbrowser (?dp_ab= ooit gezet) ziet de test ook vóór de start, ook op pagina's zonder ?dp_ab in de URL
    var proefOpgeslagen = lees("dp-ab-proef-mvmq7ych-34xx7j") === "1";
    haalConfig().then(function (tests) {
      if (vind(tests) || !proefOpgeslagen || proefKeuze() !== null) return tests;
      return fetch(COCKPIT + "/api/abtests?publiek=1&proef=1", { mode: "cors", credentials: "omit" })
        .then(function (r) { return r.ok ? r.json() : { tests: [] }; })
        .then(function (d) { return (Array.isArray(d.tests) ? d.tests : []).map(function (t) { return Object.assign({}, t, { _proef: true }); }); })
        .catch(function () { return tests; });
    }).then(function (tests) {
      var test = vind(tests);
      var proefNu = proefKeuze() !== null || !!(test && test._proef);
      if (!test) {
        // geen lopende paginatest: niemand meer doorsturen (een proefbrowser houdt zijn proef-arm tot ?dp_ab=weg)
        if (!proefNu) { try { localStorage.removeItem("dp-ab-open-mvmq7ych-34xx7j"); } catch (e) { /* niets */ } }
        return;
      }
      var id = test.id, OK = "dp-ab-open-" + id, K = "dp-ab-groep-" + id;
      if (test.vast) { if (test.vast === "B" && !proefNu) schrijf(OK, "B"); return; }   // gehouden: geen loting, geen melding
      var loopt = !test.voorStart && !proefNu;
      if (loopt) schrijf(OK, "1");
      var proef = lees("dp-ab-proef-" + id) === "1";
      var arm = lees(K) || leesCookie("dp_ab_" + id);
      if ((arm !== "A" && arm !== "B") && ds && !ds.bot && ds.basis && lees(OK) === "1" && !proef) {
        // de eerste testpagina van deze browser: loten en meteen naar het template van de arm
        arm = Math.random() < 0.5 ? "A" : "B";
        schrijf(K, arm); cookie("dp_ab_" + id, arm, DAGEN_COOKIE);
        var doel = ds.basis + "-ab-" + arm.toLowerCase();
        if (ds.huidig !== doel) {
          try { sessionStorage.setItem("dp-split-sprong", JSON.stringify({ doel: doel, pad: location.pathname, op: Date.now() })); } catch (e) { /* niets */ }
          var u = new URL(location.href); u.searchParams.set("view", doel); location.replace(u.toString());
          return;
        }
      }
      if (arm !== "A" && arm !== "B") return;
      if (lees(OK) !== "1" && !proef) return;
      var basis = function () { var b = { t: id, v: arm, b: bezoekerId(), a: apparaat() }; if (proef) b.p = 1; return b; };
      // bezoek + tijd: alleen op een testpagina die in het template van de arm staat
      if (ds && ds.basis && ds.huidig === ds.basis + "-ab-" + arm.toLowerCase()) {
        var rij = Object.assign({ s: "bezoek", h: ds.h, w: toeval(16) }, basis());
        meld(rij);
        var zichtbaar = 0, sinds = document.visibilityState === "hidden" ? null : Date.now(), weg = false;
        var pauze = function () { if (sinds) { zichtbaar += Date.now() - sinds; sinds = null; } };
        var vertrek = function () {
          if (weg) return;
          pauze(); weg = true;
          meld(Object.assign({}, rij, { s: "tijd", n: Math.max(0, Math.min(TIJD_PAGINA_KAP_S, Math.round(zichtbaar / 1000))) }));
        };
        document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") { pauze(); vertrek(); } else if (!weg) sinds = Date.now(); });
        window.addEventListener("pagehide", vertrek);
      }
      // toevoeging: elke toevoeging op elke pagina; het kenmerk op de wagen bij de eerste
      var kenmerk = false, laatsteSubmit = 0;
      var bijToevoeging = function (handles, viaSubmit) {
        // een formulier dat het thema zelf met fetch verstuurt, telt één keer (de submit), niet twee
        if (viaSubmit) laatsteSubmit = Date.now(); else if (Date.now() - laatsteSubmit < 4000) return;
        var h = handles && handles[0] && /^[a-z0-9][a-z0-9-]{1,80}$/.test(handles[0]) ? handles[0] : (handleVanPad() || "wagen");
        if (!/^[a-z0-9][a-z0-9-]{1,80}$/.test(h)) h = "wagen";
        meld(Object.assign({ s: "toevoeging", h: h, w: toeval(16) }, basis()));
        // het kenmerk na elke toevoeging, en 4 s later nog eens: de lade (Kaching) werkt de wagen vlak erna zelf bij
        // en in de proef van 24-10 ontbrak het kenmerk daardoor één keer op drie
        kenmerk = true; kenmerkOpWagen(id, arm);
        setTimeout(function () { kenmerkOpWagen(id, arm); }, 4000);
      };
      // op elke pagina: ligt er al iets in de wagen zonder (of met een ander) kenmerk, dan alsnog zetten
      try {
        fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.ok ? r.json() : null; }).then(function (w) {
          if (w && w.item_count > 0 && (!w.attributes || w.attributes["ab_" + id] !== arm)) kenmerkOpWagen(id, arm);
        }).catch(function () {});
      } catch (e) { /* niets */ }
      var raak = function (url) { try { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || "")); } catch (e) { return false; } };
      var handlesUit = function (j) {
        var uit = [];
        var neem = function (x) { if (x && typeof x.handle === "string") uit.push(x.handle); };
        if (j && Array.isArray(j.items)) j.items.forEach(neem); else neem(j);
        return uit;
      };
      if (window.fetch) {
        var oudFetch = window.fetch;
        window.fetch = function (invoer) {
          var url = typeof invoer === "string" ? invoer : (invoer && invoer.url);
          var p = oudFetch.apply(this, arguments);
          if (raak(url)) p.then(function (r) {
            if (!r || !r.ok) return;
            try { r.clone().json().then(function (j) { bijToevoeging(handlesUit(j)); }, function () { bijToevoeging([]); }); }
            catch (e) { bijToevoeging([]); }
          }, function () {});
          return p;
        };
      }
      if (window.XMLHttpRequest) {
        var oudOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (methode, url) {
          if (raak(url)) this.addEventListener("load", function () {
            if (this.status < 200 || this.status >= 300) return;
            var h = []; try { h = handlesUit(JSON.parse(this.responseText)); } catch (e) { /* geen JSON */ }
            bijToevoeging(h);
          });
          return oudOpen.apply(this, arguments);
        };
      }
      // een gewoon formulier (de koopknop van het nieuwe ontwerp post /cart/add): de pagina is weg vóór een fetch-haak vuurt
      document.addEventListener("submit", function (e) {
        var f = e.target;
        if (f && f.getAttribute && raak(f.getAttribute("action"))) bijToevoeging([handleVanPad()], true);
      }, true);
    }).catch(function () {});
  }

  /* ── de HOMEPAGE-TEST (25-10-2026, test mvo0o1e5-nqo32i van Cas, recept "home-template"; akkoord Damian sessie 0a4b2eef ·
     2026-10-25T15:43:13Z: "Ja: Dailyplay als A/B-test, ..."). Maat Cas: bounce op de homepagelanding, daarnaast "in
     winkelwagen" per landing, verkopen als rem; mobiel én desktop. De loting en de doorsturing naar ?view=home-ab-a|b doet
     snippets/dp-split.liquid VÓÓR de eerste weergave, op het shop-metaveld dailyplay.home_ab (window.dpSplitHome; de kluis
     zet dat veld, lib/home-ab.js). Dit deel meldt alleen, met de arm, en voor de proef als proef:
       · LANDING: begint een sessie (dezelfde sessie als de hero-test: 30 minuten) op de homepage in het template van de arm,
         dan "landing" met een eigen weergave-id; de volgende paginaweergave in die sessie meldt "vervolg" (sessie()); geen
         vervolg = bounce. "tijd" = de zichtbare seconden op die homepage, afgekapt op TIJD_KAP_S.
       · WAGEN: de eerste toevoeging aan de wagen in een sessie die zo'n landing had, op elke pagina, meldt "wagen" met de
         weergave van de landing (één per landing). Elke toevoeging van een browser met een homepage-arm zet het
         wagenkenmerk ab_<test> = arm (verkopen per arm), ook als de sessie niet op de homepage begon.
     Loopt de test niet (stand "0", of B gehouden: "B"), dan meldt dit niets en zet het geen kenmerk. */
  var HOME_TEST = "mvo0o1e5-nqo32i";
  var HOME_STAND = "dp-ab-home-stand";
  function startHomeTest(ss) {
    var dh = window.dpSplitHome || null;
    var arm = lees("dp-ab-groep-" + HOME_TEST) || leesCookie("dp_ab_" + HOME_TEST);
    if (dh && dh.stand != null) schrijf(HOME_STAND, String(dh.stand));
    if (arm !== "A" && arm !== "B") return;
    var proef = lees("dp-ab-proef-" + HOME_TEST) === "1";
    var stand = dh && dh.stand != null ? String(dh.stand) : lees(HOME_STAND);
    if (stand !== "1" && !proef) return;
    var doorgaan = function () {
      // LANDING: alleen op de homepage in het template van de arm, bij het begin van een sessie (de proef altijd)
      if (dh && dh.huidig === "home-ab-" + arm.toLowerCase() && (ss.nieuw || proef)) {
        var basis = { t: HOME_TEST, v: arm, h: "home", w: toeval(16), b: bezoekerId(), a: apparaat() };
        if (proef) basis.p = 1;
        meld(Object.assign({ s: "landing" }, basis));
        var s = leesSessie() || { laatst: Date.now(), id: toeval(16) };
        s.landing = { basis: basis, vervolg: false, wagen: false };
        schrijf(SESSIE_SLEUTEL, JSON.stringify(s));
        var zichtbaar = 0, sinds = document.visibilityState === "hidden" ? null : Date.now(), weg = false;
        var pauze = function () { if (sinds) { zichtbaar += Date.now() - sinds; sinds = null; } };
        var vertrek = function () {
          if (weg) return;
          pauze(); weg = true;
          meld(Object.assign({ s: "tijd", n: Math.max(0, Math.min(TIJD_KAP_S, Math.round(zichtbaar / 1000))) }, basis));
        };
        document.addEventListener("visibilitychange", function () { if (document.visibilityState === "hidden") vertrek(); else if (!weg) sinds = Date.now(); });
        window.addEventListener("pagehide", vertrek);
      }
      // WAGEN per landing en het kenmerk op de wagen, bij de eerste toevoeging op deze pagina
      bewaakToevoegen(function () {
        var s = leesSessie();
        if (s && s.landing && s.landing.basis && s.landing.basis.t === HOME_TEST && !s.landing.wagen) {
          meld(Object.assign({}, s.landing.basis, { s: "wagen" }));
          s.landing.wagen = true;
          schrijf(SESSIE_SLEUTEL, JSON.stringify(s));
        }
        // nog eens na 4 s: de lade (Kaching) werkt de wagen vlak erna zelf bij (zelfde reden als bij de paginatest)
        kenmerkOpWagen(HOME_TEST, arm);
        setTimeout(function () { kenmerkOpWagen(HOME_TEST, arm); }, 4000);
      });
    };
    // op de homepage is het metaveld de bron (dp-split las het); elders de onthouden stand, getoetst aan de cockpit: staat de
    // test daar niet (meer) als lopend, dan wordt de stand vergeten en meldt deze pagina niets
    if (dh || proef) { doorgaan(); return; }
    haalConfig().then(function (tests) {
      var loopt = false;
      for (var i = 0; i < tests.length; i++) { var t = tests[i]; if (t && t.id === HOME_TEST && !t.vast && !t.voorStart) loopt = true; }
      if (!loopt) { schrijf(HOME_STAND, "0"); return; }
      doorgaan();
    }).catch(function () {});
  }

  function start() {
    // de homepage-splitsing stuurt deze browser al door naar het template van zijn arm: op deze pagina niets doen,
    // anders telt de sessie hier al en is de landing op de echte pagina geen begin van een sessie meer
    if (window.dpSplitHome && window.dpSplitHome.springt) return;
    var ss = sessie();
    try { startHero(ss); } catch (e) { /* de homepage blijft wat hij was */ }
    try { startHeroWagen(); } catch (e) { /* alleen de wagen-telling van de hero-test valt weg */ }
    try { startLade(); } catch (e) { /* de lade blijft wat Kaching tekent */ }
    try { startKeuzehulpWagen(); } catch (e) { /* alleen de wagen-telling van de keuzehulp valt weg */ }
    try { startPaginaTest(); } catch (e) { /* de paginatest meldt dan niets; de doorsturing staat in dp-split */ }
    try { startHomeTest(ss); } catch (e) { /* de homepage-test meldt dan niets; de doorsturing staat in dp-split */ }
    var handle = handleVanPad();
    if (!handle) return;
    // de clip staat vast in het thema (VAST_CLIP); zetClip vindt op het nieuwe ontwerp geen galerij en doet dan niets
    try { if (VAST_CLIP.clips[handle]) zetClip(VAST_CLIP, handle); } catch (e) { /* de galerij blijft wat hij was */ }
    haalConfig().then(function (tests) {
      var test = null;
      for (var i = 0; i < tests.length; i++) {
        var t = tests[i];
        if (t && t.kanaal === "shop" && t.recept && t.recept.soort !== "hero-beeld" && t.recept.soort !== "lade-upsell" && Array.isArray(t.recept.handles) && t.recept.soort !== "thema-template" && t.recept.soort !== "home-template" && t.id !== VAST_CLIP.test && t.recept.handles.indexOf(handle) >= 0) { test = t; break; }
      }
      if (!test) return;
      // gehouden, nog niet in het thema gebouwd (23-10, lib/abtests.js gedwongenVariant): iedereen B, geen loting, geen melding
      if (test.vast) { if (test.vast === "B" && test.recept.soort === "galerij-clip") zetClip(test.recept, handle); return; }
      var variant = variantVoor(test.id);
      if (!variant) return;
      var proef = proefKeuze() !== null;
      var weergave = toeval(16);
      var bezoeker = bezoekerId();
      var gedaan = false;
      if (variant === "B") {
        if (test.recept.soort === "galerij-clip") gedaan = zetClip(test.recept, handle);
      } else {
        gedaan = true;   // A is "zoals nu", en dat lukt altijd
      }
      // B zonder clip voor deze pop = deze pagina kon de test niet dragen: telt als "geen"
      var gemeteVariant = gedaan ? variant : "geen";
      var basis = { t: test.id, v: gemeteVariant, h: handle, w: weergave, b: bezoeker, a: apparaat() };
      if (proef) basis.p = 1;
      meld(Object.assign({ s: "bezoek" }, basis));
      if (gemeteVariant === "geen") return;
      bewaakToevoegen(function () {
        meld(Object.assign({ s: "toevoeging" }, basis));
        kenmerkOpWagen(test.id, variant);
      });
    }).catch(function () {});
  }

  try {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  } catch (e) { /* de pagina blijft wat hij was */ }
})();
